import { useSmokeballApp } from "@smart/itops-smokeball-app-dom";

import { dlClassNames } from "./class-names";

const UserDebug = () => {
  const { context } = useSmokeballApp();

  return (
    <dl className={dlClassNames}>
      <dt>User</dt>
      <dd>{context?.userId}</dd>
      <dt>Team</dt>
      <dd>{context?.firmId}</dd>
    </dl>
  );
};

export { UserDebug };
